import React, {useEffect} from "react";
import {AdministrativeRolesTable} from "../../components/administrative-roles/AdministrativeRolesTable";
import {useSearchAdministrativeRolesGuidePageQuery} from "../../store/backend-api/backend.api";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {useAppSelector} from "../../hooks/useAppSelector";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {DEFAULT_ADMINISTRATIVE_ROLE_GUIDE_FILTER} from "../../model/filters/DefaultFilters";
import {useDataActions} from "../../hooks/useDataActions";
import {tablePageStyle} from "../../utils/TailwindStyles";

export function AdministrativeRolesGuide() {
    const {addData} = useDataActions()

    const state = useAppSelector(state => state.sessionStorage.filters)
    const filter = state[TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER].filter

    const data = useAppSelector(state => state.data.data[TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER])

    const {data: tablePage} = useSearchAdministrativeRolesGuidePageQuery(filter);

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_ADMINISTRATIVE_ROLE_GUIDE_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (
        <div className={tablePageStyle}>
            <GuideTopBox tableFilterKey={TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER}
                         createNavigationURL={'/administrative-roles/new'}
                         searchInfo={"Поиск по ID и наименованию роли."}/>
            {data && <AdministrativeRolesTable data={data}/>}
        </div>
    )
}